import { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  reportDetailsData,
  reportDetailsSummary,
  changeTheCampaign,
  updateTheCampaignSchedule,
  download,
} from './../../store/ReportDetails/actionCreator'
import { CircularProgress, Button, Typography } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import HeaderTitle from '../Header/HeaderTitle'
import { Helmet } from 'react-helmet'
import { displayReadableTime } from '../../services/displayReadableTime'
import ResponseChart from './ResponseChart'
import CampaignCompletionChart from './CampaignCompletionChart'
import { Link } from 'react-router-dom'
import { withAuth } from '@praxis/component-auth'
import CampaignDetailsItem from '../ReportDetailsLayout/CampaignDetailsItem'
import CampaignSummaryItem from '../ReportDetailsLayout/CampaignSummaryItem'
import SelectTimezoneItem from '../ReportingPage/SelectTimezoneItem'
import { setTimezoneData } from './../../store/ReportJobs/actionCreator'
import { object, func, string, shape, bool } from 'prop-types'
import { useOutletContext } from 'react-router-dom'
import SelectResponseItem from '../ReportingPage/SelectResponseItem'

function withOutletContext(WrappedComponent) {
  return function WrapperComponent(props) {
    const outletContext = useOutletContext()
    return <WrappedComponent {...props} outletContext={outletContext} />
  }
}

const styles = (theme) => ({
  button: {
    margin: theme.spacing(1),
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  noDecoration: {
    textDecoration: 'none',
    '&:visited, &:hover, &:focus, &:link, &:active': {
      textDecoration: 'none',
    },
  },
  spinner: {
    color: theme.palette.primary.main,
  },
  centerDiv: {
    margin: 'auto',
    padding: '10px',
    textAlign: 'center',
  },
  centerSummary: {
    margin: 'auto',
    width: '75%',
    textAlign: 'center',
  },
})

export class ReportDetailsTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      blossomID: '',
      campaignActive: true,
      jobID: '',
      headerTitle: '',
      newScheduleData: null,
      dbScheduleData: null,
      page: 0,
      pageSize: 10,
      timezoneDataFromChild: '',
      response: null,
      justFetchedResponse: false,
    }
    this.goBack = this.goBack.bind(this)
  }

  UNSAFE_componentWillMount(nextProps) {
    const { jobID, blossomID, timezoneDataFromChild, response } = this.props

    this.setState({
      jobID,
      blossomID,
      timezoneDataFromChild: timezoneDataFromChild, // if passed
      headerTitle: this.setTitle(blossomID),
      response: response,
    })

    this.setContactData(blossomID, jobID, 0, 10, response)
    this.setReportSummary(jobID, blossomID)
  }

  setTitle(blossomID) {
    let myTitle = ''
    if (blossomID === 'bcp') {
      myTitle = myTitle + 'BCP Campaign Details'
    } else if (blossomID === 'c3alert') {
      myTitle = myTitle + 'C3 Campaign Details'
    } else if (blossomID === 'ceebackup') {
      myTitle = myTitle + 'CEE Backup Campaign Details'
    } else if (blossomID === 'fmocdc') {
      myTitle = myTitle + 'FMOC DC Campaign Details'
    } else if (blossomID === 'precall') {
      myTitle = myTitle + 'Product Recall Campaign Details'
    } else if (blossomID === 'CI00598283') {
      myTitle = myTitle + 'HR Campaign Details'
    } else if (blossomID === 'c3aalert') {
      myTitle = myTitle + 'C3A Campaign Details'
    } else if (blossomID === 'developer') {
      myTitle = myTitle + 'Developer Campaign Details'
    } else if (blossomID === 'shipt') {
      myTitle = myTitle + 'Shipt Campaign Details'
    }
    return myTitle
  }

  // updating the returned data in an ummutable safe method.  Mostly to make it human readable
  scrubData(jsonList) {
    var newData1 = jsonList.map((el) => {
      if (el.contact_attempt_time !== 'None') {
        return Object.assign({}, el, {
          contact_attempt_time: displayReadableTime(
            el.contact_attempt_time,
            this.props.timezoneData,
          ),
        })
      }
      return el
    })
    var newData2 = newData1.map((el) => {
      if (el.last_nw_disposition_time !== '') {
        return Object.assign({}, el, {
          last_nw_disposition_time: displayReadableTime(
            el.last_nw_disposition_time,
            this.props.timezoneData,
          ),
        })
      }
      return el
    })
    var newData4 = newData2.map((el) => {
      if (el.contact_desc === 'SMS Queued') {
        return Object.assign({}, el, { contact_desc: 'SMS Sent' })
      }
      return el
    })
    var newData5 = newData4.map((el) => {
      if (el.result === 'Positive' && el.contact_type === 'Phone') {
        return Object.assign({}, el, { contact_desc: 'Safe-Phone' })
      }
      return el
    })
    var newData6 = newData5.map((el) => {
      if (el.result === 'Negative' && el.contact_type === 'Phone') {
        return Object.assign({}, el, { contact_desc: 'Follow-up-Phone' })
      }
      return el
    })
    var newData7 = newData6.map((el) => {
      if (el.result === 'Positive' && el.contact_type === 'SMS') {
        return Object.assign({}, el, { contact_desc: 'Safe-SMS' })
      }
      return el
    })
    var newData8 = newData7.map((el) => {
      if (el.result === 'Negative' && el.contact_type === 'SMS') {
        return Object.assign({}, el, { contact_desc: 'Follow-up-SMS' })
      }
      return el
    })
    var newData9 = newData8.map((el) => {
      if (el.result === 'Positive' && el.contact_type === 'Email') {
        return Object.assign({}, el, { contact_desc: 'Safe-Email' })
      }
      return el
    })
    var newData10 = newData9.map((el) => {
      if (el.result === 'Negative' && el.contact_type === 'Email') {
        return Object.assign({}, el, { contact_desc: 'Follow-up-Email' })
      }
      return el
    })
    return newData10
  }
  setContactData(blossomID, jobID, page, pageSize, response) {
    this.props.reportDetailsData(blossomID, jobID, page, pageSize, response)
  }

  setReportSummary(jobID, blossomID) {
    this.props.reportDetailsSummary(jobID, blossomID)
  }

  goBack() {
    this.props.navigate(-1) // ← This replaces history.goBack()
  }

  timezoneDataCallback = (dataFromChild) => {
    this.setState({ timezoneDataFromChild: dataFromChild })
    // Refresh data whenever timezone changes to make sure updated schedule data is pulled
    this.setReportSummary(this.state.jobID, this.state.blossomID)
  }

  responseDataCallback = (dataFromChild) => {
    this.setState({ response: this.response })
    // Refresh data whenever timezone changes to make sure updated schedule data is pulled
    this.setReportSummary(this.state.jobID, this.state.blossomID)
  }

  contactDataCallback = (
    blossomID,
    jobIDFromChild,
    pageFromChild,
    pageSizeFromChild,
    response,
  ) => {
    this.setContactData(
      blossomID,
      jobIDFromChild,
      pageFromChild,
      pageSizeFromChild,
      response,
    )
  }

  pageDataCallback = (page) => {
    this.setState({ page: page })
  }

  pageSizeDataCallback = (pageSize) => {
    this.setState({ pageSize: pageSize })
  }

  selectNotificationCallbacks(jsonList) {
    if (jsonList == null) {
      jsonList = []
    }
    let newArray = []
    jsonList.forEach(function (element) {
      let tempObject = newArray.find(
        (o) => o.contact_id === element['contact_id'],
      )
      let strip = true
      if (tempObject) {
        // the object exists in our temporary array object
        if (tempObject['contact_desc'].includes('Safe')) {
          // found the contact_id with safe in the temporary array
          // if our current object is set to follow, mark our temporary array element for deletion, as we want to always default to Follow up in case of conflict
          if (!element['contact_desc'].includes('Help')) {
            strip = false
          }
        } else if (tempObject['contact_desc'].includes('Help')) {
          // if our temp array already is set to follow, don't update it!
          strip = false
        }
      } else {
        // if the contact id doesn't exist in our temporary array, add it!
        newArray.push({
          contact_id: element['contact_id'],
          contact_desc: element['contact_desc'],
        })
      }
      if (strip) {
        // loop through our new array to find the location of the element to strip
        for (var i = 0; i < newArray.length; i++) {
          if (newArray[i].contact_id === element['contact_id']) {
            // strip this element from the array
            newArray.splice(i, 1)
            // add the new array element
            newArray.push({
              contact_id: element['contact_id'],
              contact_desc: element['contact_desc'],
            })
            break
          }
        }
      }
    })
    // Populate campaign array only with records that have not been contacted
    let callbackObj = {}
    for (var i = 0; i < newArray.length; i++) {
      var contact_desc = newArray[i].contact_desc
      if (!contact_desc.includes('Safe') && !contact_desc.includes('Help')) {
        callbackObj[String(newArray[i].contact_id)] = true
      }
    }
    return callbackObj
  }
  selectNotifyOnly() {
    let notifyOnly = false
    if (
      this.props.reportSummary['campaign_summary'][
        'message_response_positive'
      ] === null ||
      this.props.reportSummary['campaign_summary'][
        'message_response_positive'
      ] === ''
    ) {
      notifyOnly = true
    }
    return notifyOnly
  }

  changeCampaignStatus(action) {
    this.props.changeTheCampaign(action, this.state.blossomID, this.state.jobID)
  }

  downloadData() {
    this.props.download(this.state.jobID, this.state.blossomID)
  }

  static defaultProps = {}
  render() {
    const {
      classes,
      headerTitle,
      fetchingState,
      contactDataFetchingState,
      reportSummary,
      contactData,
      isAuthenticated,
      isAuthorized,
    } = this.props
    const { timezoneDataFromChild, blossomID, jobID, page, pageSize } =
      this.state
    let tempTitle =
      'T.O.M. - Target Outreach Manager - ' + this.state.headerTitle
    let groupTitle = <HeaderTitle title={tempTitle} />

    // Create variables from values of matching keys
    let toRender = <br />
    let tempStatus = ''
    if (
      fetchingState === false &&
      reportSummary === null &&
      contactData === null
    ) {
      toRender = (
        <div className={classes.centerDiv}>
          <Typography component="span" variant="h6">
            Report Not Available, Try Again in 30 Seconds
          </Typography>
        </div>
      )
    } else if (fetchingState === true) {
      toRender = (
        <div className={classes.centerDiv}>
          <CircularProgress className={classes.spinner} thickness={7} />
          <h3>loading...</h3>
        </div>
      )
    } else if (contactData != null && reportSummary != null) {
      let stopButton = ''
      let pauseButton = ''
      let resumeButton = ''
      tempStatus = reportSummary['reporting_summary']['data']['status']
      if (
        tempStatus === 'JOB_ACTIVE' ||
        tempStatus === 'JOB_QUEUED' ||
        tempStatus === 'JOB_PAUSED' ||
        tempStatus === 'JOB_CONTACTS_COMPLETE'
      ) {
        stopButton = (
          <Button
            onClick={() => {
              this.changeCampaignStatus('stop')
            }}
            className={classes.button}
          >
            Stop Campaign
          </Button>
        )
      } else if (tempStatus === 'JOB_STOPPING') {
        stopButton = <Button disabled>Campaign Stopping</Button>
      }
      if (tempStatus === 'JOB_ACTIVE') {
        pauseButton = (
          <Button
            onClick={() => {
              this.changeCampaignStatus('pause')
            }}
            className={classes.button}
          >
            Pause Campaign
          </Button>
        )
      } else if (tempStatus === 'JOB_RESUME') {
        pauseButton = <Button disabled>Campaign Resuming</Button>
      }
      if (tempStatus === 'JOB_PAUSE' || tempStatus === 'JOB_PAUSED') {
        resumeButton = (
          <Button
            onClick={() => {
              this.changeCampaignStatus('resume')
            }}
            className={classes.button}
          >
            Resume Campaign
          </Button>
        )
      } else if (tempStatus === 'JOB_PAUSING') {
        resumeButton = <Button disabled>Campaign Pausing</Button>
      }

      toRender = (
        <div>
          <Button
            onClick={() => {
              this.goBack()
            }}
            className={classes.button}
          >
            Back
          </Button>
          {isAuthenticated() &&
            isAuthorized([
              'APP-OAUTH2-TOM-StoreHR',
              'APP-OAUTH2-TOM-C3',
              'APP-OAUTH2-TOM-C3A',
              'APP-OAUTH2-TOM-Recall',
            ]) &&
            Object.keys(this.selectNotificationCallbacks(contactData['data']))
              .length > 0 && (
              <Link
                to={{
                  pathname: '/followup_campaign',
                  state: {
                    listData: this.selectNotificationCallbacks(
                      contactData['data'],
                    ),
                    contactMethods:
                      reportSummary['campaign_summary']['contact_priority'],
                    contactDelay:
                      reportSummary['campaign_summary']['contactdelay'],
                    notifyOnly: this.selectNotifyOnly(),
                    messageTitle:
                      reportSummary['campaign_summary']['message_title'],
                    messagePhone:
                      reportSummary['campaign_summary']['message_phone'],
                    messageEmail:
                      reportSummary['campaign_summary']['message_email'],
                    messageSMS:
                      reportSummary['campaign_summary']['message_sms'],
                    messageResponsePositive:
                      reportSummary['campaign_summary'][
                        'message_response_positive'
                      ],
                    messageResponseNegative:
                      reportSummary['campaign_summary'][
                        'message_response_negative'
                      ],
                    messageResponsePositiveEs:
                      reportSummary['campaign_summary'][
                        'message_response_positive_es'
                      ],
                    messageResponseNegativeEs:
                      reportSummary['campaign_summary'][
                        'message_response_negative_es'
                      ],
                    ciDataInput: blossomID,
                    startAtStep: 1,
                  },
                }}
                className={classes.noDecoration}
                exact={'true'}
              >
                <Button className={classes.button}>
                  Callback Non-Responses
                </Button>
              </Link>
            )}
          {stopButton}
          {pauseButton}
          {resumeButton}
          <div>
            <SelectTimezoneItem
              callbackFromParentTimezone={this.timezoneDataCallback}
              timezoneFromParent={timezoneDataFromChild}
            />
          </div>
          <div>
            {!this.selectNotifyOnly() && (
              <SelectResponseItem
                responseFromParent={this.state.response} // Pass the current state value
                callbackFromParentResponse={(response) => {
                  this.setState({ response }, () => {
                    this.contactDataCallback(
                      this.state.blossomID,
                      this.state.jobID,
                      this.state.page,
                      this.state.pageSize,
                      this.state.response, // Pass the updated response value
                    )
                  })
                }}
              />
            )}
          </div>
          <div className={classes.centerDiv}>
            <div style={{ display: 'inline-block' }}>
              <ResponseChart
                unique_response_summary={
                  reportSummary['unique_response_summary']
                }
              />
            </div>
            <div style={{ display: 'inline-block' }}>
              <CampaignCompletionChart
                unique_contacts={
                  reportSummary['reporting_summary']['unique_contacts']
                }
                data={reportSummary['reporting_summary']['data']}
              />
            </div>
          </div>
          <CampaignDetailsItem
            blossomIDFromParent={blossomID}
            jobIDFromParent={jobID}
            reportDetailsDataFromParent={contactData}
            reportDetailsSummaryFromParent={reportSummary}
            callbackFromParentContactData={this.contactDataCallback}
            timezoneDataFromParent={timezoneDataFromChild}
            pageFromParent={page}
            pageSizeFromParent={pageSize}
            callbackFromParentPage={this.pageDataCallback}
            callbackFromParentPageSize={this.pageSizeDataCallback}
            fetchingState={contactDataFetchingState}
            callbackFromParentResponse={this.contactDataCallback}
          />

          <div className={classes.centerDiv}>
            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={() => {
                this.downloadData()
              }}
            >
              Download Data
            </Button>
          </div>
          <div className={classes.centerSummary}>
            <CampaignSummaryItem
              blossomIDFromParent={blossomID}
              jobIDFromParent={jobID}
              dbScheduleDataFromParent={
                reportSummary['campaign_summary']['schedule']
              }
              campaign_summary={reportSummary['campaign_summary']}
              timezoneDataFromParent={timezoneDataFromChild}
            />
          </div>
        </div>
      )
    }

    return (
      <div>
        {groupTitle}
        <Helmet>
          <title>{headerTitle}</title>
        </Helmet>
        {toRender}
      </div>
    )
  }
}

ReportDetailsTable.propTypes = {
  // classes: PropTypes.object.isRequired,
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      reportDetailsData,
      reportDetailsSummary,
      changeTheCampaign,
      updateTheCampaignSchedule,
      setTimezoneData,
      download,
    },
    dispatch,
  )

const mapStateToProps = (state) => ({
  contactData: state.reportDetails.detailsData,
  reportSummary: state.reportDetails.summaryData,
  fetchingState: state.reportDetails.fetching,
  contactDataFetchingState: state.reportDetails.contactDataFetching,
  dbScheduleData: state.reportDetails.dbScheduleData,
  timezoneData: state.reportJobs.timezoneData,
})

const mapAuthToProps = (auth) => ({
  isAuthenticated: auth.isAuthenticated,
  isAuthorized: auth.isAuthorized,
})

const ReportDetailsTableWithContext = withOutletContext(ReportDetailsTable)
const StyledConnectedReportDetailsTable = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(ReportDetailsTableWithContext))

export default withAuth(mapAuthToProps)(StyledConnectedReportDetailsTable)

ReportDetailsTable.propTypes = {
  classes: object,
  headerTitle: string,
  fetchingState: bool,
  contactDataFetchingState: bool,
  reportSummary: shape({
    campaign_summary: object,
    reporting_summary: object,
    unique_response_summary: object,
  }),
  contactData: shape({
    data: object,
  }),
  isAuthenticated: func,
  isAuthorized: func,
}
